import { Card } from "@arco-design/web-react";

import { usePublishedBanner } from "../api/hooks/usePublishedBanner";
import { resolveBannerUrl } from "../utils/bannerUrl";

import "./Banner.css";

type BannerProps = {
  /** legacy = card-framed home banner (all flag-off tenants). hero = full-bleed preview dashboard only. */
  variant?: "legacy" | "hero";
  size?: number;
  style?: React.CSSProperties;
};

export const Banner = ({ variant = "legacy", style }: BannerProps) => {
  const { data: banner } = usePublishedBanner();

  if (!banner?.url) {
    return null;
  }

  const src = resolveBannerUrl(banner.url);

  const image = (
    <img
      key={banner.id}
      className="app-banner__image"
      src={src}
      alt=""
      loading="eager"
      decoding="async"
    />
  );

  if (variant === "hero") {
    return (
      <div className="app-banner" style={style}>
        {image}
      </div>
    );
  }

  return (
    <Card className="card-with-icon-hover own-card app-banner__card" style={style}>
      {image}
    </Card>
  );
};
